module.exports = __webpack_public_path__ + "static/media/test4_2.d3a8ff20.png";